import type React from 'react'

import { useAccess } from '../lib/useAccess'

type AccessProps = {
	fallback?: React.ReactNode
	children: React.ReactNode
	roles?: string[]
	permissions?: string[]
}
export const Access = ({
	permissions,
	roles,
	fallback = null,
	children,
}: AccessProps) => {
	const { checkPermissons, checkRole } = useAccess()

	let canAccess = false

	if (permissions) {
		canAccess = checkPermissons(permissions)
	}
	if (roles) {
		canAccess = checkRole(roles)
	}

	return canAccess ? children : fallback
}
